window.$ = window.jQuery = require('jquery');
import Swal from 'sweetalert2';

common.View.create('website.redeem.Index', {

    onDOMLoad()
    {
        this.initSweetAlertForChoosePrize()
    },

    initSweetAlertForChoosePrize()
    {
        $('[data-confirmation]').each(function(){
            var message = $(this).data('confirmation');

            $(this).on('submit', function(e){
                e.preventDefault();

                var form = this;
                var prize = $(form).find('[name="prize_id"]:checked').attr('title');

                new Swal({
                    title: prize,
                    text: message,
                    confirmButtonText: 'Ja',
                    cancelButtonText: 'Nee',
                    showCancelButton: true,
                    customClass: {
                        confirmButton: 'mainBgColor !',
                        cancelButton: '!bg-black hover:opacity-75',
                    }
                })
                    .then(data => {
                        if (data.isConfirmed) {
                            form.submit();
                        }
                    });
            });

        });

    },


});
